import { render, staticRenderFns } from "./oc-logo.vue?vue&type=template&id=4d054442&scoped=true&"
import script from "./oc-logo.vue?vue&type=script&lang=js&"
export * from "./oc-logo.vue?vue&type=script&lang=js&"
import style0 from "./oc-logo.vue?vue&type=style&index=0&id=4d054442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d054442",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d054442')) {
      api.createRecord('4d054442', component.options)
    } else {
      api.reload('4d054442', component.options)
    }
    module.hot.accept("./oc-logo.vue?vue&type=template&id=4d054442&scoped=true&", function () {
      api.rerender('4d054442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/oc-logo.vue"
export default component.exports